import { render, staticRenderFns } from "./liquidation.vue?vue&type=template&id=402802ec"
import script from "./liquidation.vue?vue&type=script&lang=js"
export * from "./liquidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports